import { Box } from "@mui/material";
import { scoreInsight } from "../../utils/functions";

const ScoreInsights = ({relevancy, sentiments}) => {
    return (
        <>
            {relevancy && <Box><strong>Relevancy</strong><br/>{relevancy === '-' ? '-' : scoreInsight(relevancy)}</Box>}
            {sentiments && <Box sx={{mt: relevancy ? 1 : null}}><strong>Sentiment</strong><br/>{sentiments === '-' ? '-' : scoreInsight(sentiments)}</Box>}
        </>
    )
};

export default ScoreInsights;